<a
  class="tw-block tw-cursor-pointer tw-border-none tw-bg-background tw-px-4 tw-py-2 tw-text-left !tw-text-main tw-no-underline hover:tw-bg-secondary-100 hover:tw-no-underline focus:tw-z-50 focus:tw-bg-secondary-100 focus:tw-outline-none focus:tw-ring focus:tw-ring-primary-700 focus:tw-ring-offset-2 active:!tw-ring-0 active:!tw-ring-offset-0"
  href="#"
  appStopClick
  (click)="submit(returnUri, true)"
>
  <i class="bwi bwi-fw bwi-link" aria-hidden="true"></i>
  {{ "linkSso" | i18n }}
</a>
